'use strict';

angular.module('jericho')

.config(function ($stateProvider)
{
    $stateProvider
    .state('guest', {
        abstract: true,
        template: '<div class="forgot-password-page" ui-view></div>'
    });

    $stateProvider
    .state('guest.login', {
        onEnter: ['$state', ($state) =>
        {
            $state.go('login');
        }]
    });
});
